<div
  id="ShareComponent"
  class="card esri-widget animation-on-tool-open"
  #shareComponentRef
  [hidden]="hiddenContainer"
  gisDraggableWidget
  [dragHandle]="dragArea"
>
  <!--- the card header -->
  <div class="card-header" #dragArea>
    <div class="row">
      <div class="col-md-9" translate>
        {{ 'WIDGET.SHARE.PANEL_HEADING' }}
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>

  <!-- the card body -->
  <div class="card-body">
    <div class="form-row">
      <div class="form-group col-12">
        <label for="inputMapShare" translate>WIDGET.SHARE.SHARE_LABEL</label>
        <input
          #urlInput
          type="text"
          autocomplete="off"
          id="inputMapShare"
          [(ngModel)]="inputValue"
          name="inputMapShare"
          readonly
          class="form-control form-control-sm"
        />
      </div>
      <!--- buttons -->
      <div class="form-group col-12">
        <button class="btn btn-primary btn-block" (click)="copyTextToClipboard(urlInput)">
          <i class="material-icons md-18 md-btn-align">content_copy</i>
          <span translate>WIDGET.SHARE.COPY</span>
        </button>
      </div>
    </div>
  </div>
</div>
